// extracted by mini-css-extract-plugin
export default {"verify":"styles_verify__NfQzh","inlineButton":"styles_inlineButton__Fyq3v"};